/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type AdWaypointPassengersWaypointFragment = {
  __typename?: 'FccWaypoint'
  id: string
  fccStop: {
    __typename?: 'FccStop'
    id: string | null
    names: Partial<Record<'de' | 'en' | 'no', string>>
  } | null
  stopWithServiceArea: {
    __typename?: 'Stop'
    id: string
    serviceArea: { __typename?: 'ServiceArea'; id: string }
  } | null
  actions: Array<
    | {
        __typename: 'FccWaypointDeliveryAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
      }
    | { __typename?: 'FccWaypointHubReturnAction' }
    | {
        __typename: 'FccWaypointPickupAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
        notShownUpAt: string | null
        tripIsCancelled: boolean | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
      }
    | { __typename?: 'FccWaypointReallocationAction' }
  >
}

export const AdWaypointPassengersWaypointFragmentDoc = gql`
    fragment AdWaypointPassengersWaypoint on FccWaypoint {
  id
  ...GetPassengersWaypoint
}
    `
